import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-article",
  "use": "icon-article-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-article\"><defs><style type=\"text/css\"></style></defs><path d=\"M876 1024H148c-44.183 0-80-35.817-80-80V80c0-44.183 35.817-80 80-80h728c44.183 0 80 35.817 80 80v864c0 44.183-35.817 80-80 80zM247 537h372v-50H247v50z m530-250H247v50h530v-50z m0 400H247v50h530v-50z\" fill=\"#888888\" p-id=\"3044\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol